




















































import DatasourceServices from '@/services/datasource';
import { DatacollectDto, SyncColumnsInfo } from '@/services/datacollect';
import { Vue, Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class DatacollectForm3 extends Vue {
  @PropSync('formData') syncFormData!: DatacollectDto;

  dsSrv = new DatasourceServices();

  dsTypeList: any = [];
  dsList: any = [];
  tableList: any = [];

  created() {
    this.dsTypeList = [
      {key: 'MySQL', value: 'MySQL'},
      {key: 'PostgreSQL', value: 'PostgreSQL'},
      {key: 'SQLServer', value: 'SQLServer'},
      {key: 'Oracle', value: 'Oracle'},
      {key: 'elasticsearch', value: 'elasticsearch'},
      {key: 'mongoDB', value: 'mongoDB'},
      {key: 'kafka', value: 'kafka'},
      {key: 'hive', value: 'hive'},
      {key: 'hbase', value: 'hbase'},
      {key: 'csvFile', value: 'csvFile'},
      {key: 'oss', value: 'oss'},
      {key: 'restapi', value: 'restapi'},
      {key: 'redis', value: 'redis'},
      {key: 'doris', value: 'doris'}
    ];
    this.getDsList();
  }

  @Watch('syncFormData.sinkDsColumns.length')
  onFormDataChange(newVal: number, oldVal: number) {
    if(newVal !== oldVal) {
      // 操作
      this.resetSyncConfig();
    }
  }

  @Watch('syncFormData.id')
  async getDsList() {
    if (this.syncFormData.id) {
      this.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: this.syncFormData.sinkDsType });
      this.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: this.syncFormData.sinkDsId });
    } else {
      this.dsList = await this.dsSrv.getList({ status_eq: 0 });
    }
  }

  async onChangeDsType(e: string) {
    this.syncFormData.sinkDsType = e;
    this.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: e });
    this.$forceUpdate();
  }

  async onChangeDs(e: number) {
    this.syncFormData.sinkDsId = e;
    let source = this.dsList.filter((v: any) => v.id == e);
    this.syncFormData.sinkDsName = source && source.length > 0 ? source[0].dsName : '';
    if(!this.syncFormData.sinkDsType) { this.syncFormData.sinkDsType = source.dsType; } 
    this.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: e });
    this.$forceUpdate();
  }

  async onChangeTable(e: number) {
    this.syncFormData.sinkDsTableId = e;
    let table = this.tableList.filter((v: any) => v.id == e);
    this.syncFormData.sinkDsTableName = table && table.length > 0 ? table[0].tableNameEn : '';

    this.syncFormData.sinkDsColumns = await this.dsSrv.columns({ status_eq: 0, tableId_eq: e });

    this.$forceUpdate();
  }

  filterOption(input: string, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  resetSyncConfig() {
    debugger
    let syncMappings: Array<SyncColumnsInfo> = [];
    this.syncFormData.syncConfig = [];

    if(this.syncFormData.sinkDsColumns 
        && this.syncFormData.sinkDsColumns.length > 0 ) {
      this.syncFormData.sinkDsColumns.forEach((val, idx) => {
        // sink为基础，匹配source, 两者不能为空（上一步调整字段结构）
        syncMappings[idx] = {};
        syncMappings[idx].sort = idx;
        syncMappings[idx].sourceTable = this.syncFormData.sourceDsTableName;
        syncMappings[idx].sinkColumnNameEn = val.columnNameEn;
        syncMappings[idx].sinkColumnNameCn = val.columnNameCn;
        syncMappings[idx].sinkTable = this.syncFormData.sinkDsTableName;
      })
    }
    this.syncFormData.syncConfig = syncMappings.concat();
  }

  columns = [{
      title: '字段物理名',
      dataIndex: 'columnNameEn',
      key: 'columnNameEn',
      width: 120,
    },
    {
      title: '字段逻辑名',
      dataIndex: 'columnNameCn',
      key: 'columnNameCn',
      width: 120,
      scopedSlots: { customRender: 'nameCn' },
    },
    {
      title: '字段物理类型',
      dataIndex: 'dataTypeEn',
      key: 'dataTypeEn',
      width: 80,
    },
    {
      title: '字段逻辑类型',
      dataIndex: 'dataTypeCn',
      key: 'dataTypeCn',
      width: 80,
    },
    {
      title: '主键',
      dataIndex: 'pkFlag',
      key: 'pkFlag',
      width: 80,
      scopedSlots: { customRender: 'pkFlag' },
    },
    {
      title: '分区字段',
      dataIndex: 'partitionFlag',
      key: 'partitionFlag',
      width: 80,
      scopedSlots: { customRender: 'partitionFlag' },
    },
    {
      title: '启用',
      dataIndex: 'status',
      key: 'status',
      width: 80,
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 50,
      scopedSlots: { customRender: 'operation' },
    },
  ];

  removeList(index: number) {
    this.syncFormData.sinkDsColumns && this.syncFormData.sinkDsColumns.splice(index, 1);
  }

}
